<template>
  <div class="auth-page">
    <div class="back-to-home" @click="back()">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 18L9 12L15 6" stroke="#dcc49e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <div class="login-background">
      <div class="background-image"></div>
    </div>

    <div class="login-content">
      <div class="logo-wrap">
        <img :src="assets.logo" alt="brand logo" class="brand-logo">
      </div>

      <form class="login-form" @submit.prevent="doRegister()">
        <div class="field-box">
          <label class="field-inner">
            <span class="field-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="12" cy="7" r="4" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <input
              v-model.trim="username"
              type="text"
              name="account"
              placeholder="Enter Username"
              autocomplete="username"
            >
          </label>
        </div>

        <div class="field-box">
          <label class="field-inner">
            <span class="field-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <input
              v-model="password"
              type="password"
              name="password"
              placeholder="Enter Password"
              autocomplete="new-password"
            >
          </label>
        </div>

        <div class="field-box">
          <label class="field-inner">
            <span class="field-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <polyline points="14,2 14,8 20,8" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="16" y1="13" x2="8" y2="13" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="16" y1="17" x2="8" y2="17" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <polyline points="10,9 9,9 8,9" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <input
              v-model.trim="code"
              type="text"
              name="invitationCode"
              placeholder="Enter ther Invitation Code"
            >
          </label>
        </div>

        <label class="agreement-row">
          <input v-model="checked" type="checkbox" class="agreement-checkbox">
          <span class="agreement-indicator">
            <span v-if="checked" class="agreement-dot"></span>
          </span>
          <span class="agreement-text">I'm 18+ and agree to the 《Registration Terms》</span>
        </label>

        <button type="submit" class="gradient-login-btn">Sign Up</button>
      </form>

      <div class="auth-link-row">
        <button class="auth-link" @click="toLogin()">Back to login</button>
      </div>
    </div>

    <button class="support-btn" @click="openSupport">
      <img src="/img/mine/kefu.png" alt="support">
    </button>

  </div>
</template>

<script>
const ASSETS = {
  logo: '/img/login/sincere-logo.png',
  background: '/img/login/target_login_bg.jpg'
};

export default {
  data() {
    return {
      assets: ASSETS,
      checked: false,
      username: '',
      code: '',
      lang: 'en_us',
      password: ''
    };
  },
  mounted() {
    this.lang = localStorage.getItem('lang') || 'en_us';
  },
  methods: {
    async ensureBaseInfo() {
      const current = this.$store.getters.getBaseInfo || {};
      if (current && Object.keys(current).length) {
        return current;
      }

      try {
        const res = await this.$http({
          method: 'get',
          url: 'base_info'
        });
        if (res && res.data) {
          this.$store.commit('setBaseInfoValue', res.data);
          return res.data;
        }
      } catch (error) {
        return current;
      }

      return current;
    },
    normalizeRegisterMessage(message) {
      const text = String(message || '').trim();
      if (!text) {
        return 'Registration failed!';
      }

      const normalized = text.toLowerCase();
      if (normalized.includes('successful') || text.includes('成功')) {
        return 'Registration successful!';
      }
      if (text.includes('用户名') || text.includes('ユーザー名') || text.includes('账号') || text.includes('アカウント')) {
        return 'Username already exists!';
      }
      if (text.includes('邀请码') || text.includes('招待コード') || text.includes('invite')) {
        return 'Invalid invitation code!';
      }
      if (text.includes('协议') || text.includes('agreement') || text.includes('利用規約')) {
        return 'Please accept the registration terms!';
      }
      if (text.includes('密码') || text.includes('パスワード')) {
        return 'Please enter a valid password!';
      }

      return 'Registration failed!';
    },
    back() {
      return window.history.back();
    },
    toLogin() {
      this.$router.push('/Login');
    },
    async openSupport() {
      const service = await this.ensureBaseInfo();
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$router.push('/ServiceOnline');
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t('auth.username_place'));
        return;
      }
      if (!this.password) {
        this.$toast.fail(this.$t('auth.pwd_place'));
        return;
      }
      if (!this.code) {
        this.$toast.fail(this.$t('auth.invite_code_place'));
        return;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t('auth.agreement'));
        return;
      }
      this.$http({
        method: 'post',
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success('Registration successful!');
          sessionStorage.removeItem(`login_intro_shown_${res.data}`);
          sessionStorage.setItem('login_intro_pending', '1');
          localStorage.setItem('token', res.data);
          if (this.$root && typeof this.$root.refreshLoginIntroConfig === 'function') {
            this.$root.refreshLoginIntroConfig();
          }
          this.$router.push('/Mine');
        } else {
          this.$toast.fail(this.normalizeRegisterMessage(res.msg));
        }
      });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
    this.ensureBaseInfo();
  }
};
</script>

<style lang="less" scoped>
.auth-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #d9d4d9;
}

.back-to-home {
  position: absolute;
  left: 22px;
  top: 26px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: rgba(189, 183, 190, 0.48);
  backdrop-filter: blur(2px);
}

.login-background,
.background-image {
  position: fixed;
  top: 0;
  height: 100%;
}

.login-background {
  left: calc(50% - min(50%, 300px));
  width: min(100%, 600px);
  overflow: hidden;
  z-index: 0;
}

.background-image {
  inset: 0;
  width: 100%;
  height: 100%;
  background: url('/img/login/target_login_bg.jpg') no-repeat 0 0;
  background-size: auto 100%;
  animation: auth-bg-pan 70s linear infinite;
}

.login-content {
  position: relative;
  z-index: 3;
  width: 100%;
  min-height: 100vh;
  padding: 104px 16px 48px;
  display: flex;
  flex-direction: column;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  margin: 94px 0 64px;
}

.brand-logo {
  width: 116px;
  height: 116px;
  object-fit: contain;
  filter: drop-shadow(0 12px 24px rgba(108, 74, 86, 0.28));
}

.login-form {
  margin-top: 0;
}

.field-box {
  margin-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(143, 133, 146, 0.14);
}

.field-inner {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 16px;
  border: 1px solid rgba(214, 206, 214, 0.8);
  background: rgba(232, 237, 247, 0.92);
}

.field-icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  margin-right: 12px;
  align-items: center;
  justify-content: center;
  flex: none;
}

.field-icon svg {
  width: 22px;
  height: 22px;
}

.field-inner input {
  width: 100%;
  border: none;
  background: transparent;
  color: #7d6a53;
  font-size: 17px;
  outline: none;
}

.field-inner input::placeholder {
  color: #c7b299;
}

.agreement-row {
  display: flex;
  align-items: center;
  margin: 14px 0 20px;
  color: rgba(117, 92, 76, 0.92);
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.12);
}

.agreement-checkbox {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.agreement-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  border: 1px solid rgba(173, 150, 130, 0.85);
  border-radius: 50%;
  background: rgba(245, 241, 236, 0.8);
  flex: none;
}

.agreement-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #d8ab7e;
}

.agreement-text {
  line-height: 1.3;
}

.gradient-login-btn {
  width: 100%;
  height: 62px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #f7dfc5 0%, #eabf93 100%);
  color: #5e3933;
  font-size: 23px;
  font-weight: 700;
  box-shadow: 0 12px 24px rgba(181, 141, 113, 0.22);
}

.auth-link-row {
  margin-top: 12px;
  text-align: left;
}

.auth-link {
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(222, 188, 148, 0.92);
  font-size: 15px;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(110, 92, 100, 0.2);
}

.support-btn {
  position: fixed;
  right: 22px;
  bottom: 182px;
  z-index: 6;
  width: 64px;
  height: 64px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  box-shadow: 0 14px 28px rgba(225, 48, 66, 0.22);
}

.support-btn img {
  width: 100%;
  height: 100%;
  display: block;
}

@keyframes auth-bg-pan {
  0%,
  100% {
    background-position-x: 0;
  }

  50% {
    background-position-x: 100%;
  }
}

@media (min-width: 768px) {
  .auth-page {
    max-width: 600px;
    margin: 0 auto;
  }

  .login-content {
    max-width: 520px;
    margin: 0 auto;
  }
}
</style>
